import React from 'react';
import './FlyerPage.css';

const FlyerPage = () => {
  return (
    <div className="flyer-container">
      <div className="flyer-content">
        {/* Header */}
        <div className="flyer-header">
          <div className="game-logo">
            <img src="/nicoleLogo2.png" alt="NicoleCodeGirl Logo" className="logo-image" />
          </div>
          <h1 className="flyer-title">Memory Game Challenge</h1>
          <p className="flyer-subtitle">You're Invited to Play!</p>
        </div>

        {/* Main Content */}
        <div className="flyer-main">
          <div className="game-preview">
            <div className="card-grid">
              <div className="preview-card card-1">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">🎮</div>
                  <div className="card-label">GAME</div>
                </div>
              </div>
              <div className="preview-card card-2">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">💖</div>
                  <div className="card-label">LOVE</div>
                </div>
              </div>
              <div className="preview-card card-3">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">🌟</div>
                  <div className="card-label">STAR</div>
                </div>
              </div>
              <div className="preview-card card-4">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">🎯</div>
                  <div className="card-label">TARGET</div>
                </div>
              </div>
              <div className="preview-card card-5">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">🚀</div>
                  <div className="card-label">ROCKET</div>
                </div>
              </div>
              <div className="preview-card card-6">
                <div className="card-back">
                  <div className="card-pattern"></div>
                  <div className="card-question">?</div>
                </div>
                <div className="card-front">
                  <div className="card-icon">✨</div>
                  <div className="card-label">SPARKLE</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flyer-features">
            <h2 className="features-title">Why Play?</h2>
            <ul className="features-list">
              <li>🧠 <span>Improve your memory</span></li>
              <li>🏆 <span>Compete with friends</span></li>
              <li>🎨 <span>Two amazing themes: NicoleCodeGirl & Community</span></li>
              <li>⚡ <span>Quick & fun gameplay</span></li>
              <li>📱 <span>Mobile friendly</span></li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="flyer-cta">
          <div className="cta-box">
            <h3 className="cta-title">A Friend Invited You!</h3>
            <p className="cta-text">Join the memory game challenge and see how fast you can complete it! Choose from two exciting themes and compete with players worldwide.</p>
            <div className="cta-url">
              <a href="https://memory-game.nicolecodegirl.com" className="url-text" target="_blank" rel="noopener noreferrer">
                memory-game.nicolecodegirl.com
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flyer-footer">
          <p className="footer-text">© 2025 NicoleCodeGirl</p>
        </div>
      </div>
    </div>
  );
};

export default FlyerPage;
